import { create } from 'zustand';
import { sortBy } from 'lodash';
import axiosInstance from '@/plugins/axios';
import UtilsMask from '@/utils/UtilsMask';

export interface RootCnpjItem {
  value: string; // nrinsc (8 dígitos)
  title: string; // razão social
  subtitle: string; // cnpj mascarado
}

interface CompaniesState {
  rootCnpjs: RootCnpjItem[];
  loading: boolean;
  loaded: boolean;
  fetchRootCnpjs: () => Promise<void>;
}

export const useCompaniesStore = create<CompaniesState>((set, get) => ({
  rootCnpjs: [],
  loading: false,
  loaded: false,

  async fetchRootCnpjs() {
    if (get().loaded || get().loading) return;
    set({ loading: true });
    try {
      const { data } = await axiosInstance.get('agnes/companies');

      const mapped: RootCnpjItem[] = (data as any[]).map((c) => {
        const nrinsc = c.nrinsc || (c.cnpj ? String(c.cnpj).substring(0, 8) : '');
        return {
          value: nrinsc,
          title: c.razaoSocial || c.nomeFantasia || '',
          subtitle: UtilsMask.cnpj(c.cnpj || ''),
        };
      });
      set({ rootCnpjs: sortBy(mapped, ['title']), loaded: true });
    } catch (e) {
      console.error('Error fetching companies:', e);
    } finally {
      set({ loading: false });
    }
  },
}));
